import React, {FC} from 'react';
import {TextContainer} from "../components/TextContainer";
import {SubTitle} from "../components/SubTitle";

export const ImprintPage: FC = () => {
    return (
        <TextContainer>
            <div className="w-max ">
                <SubTitle>Imprint</SubTitle>
                <p>
                    Anton Ebel<br/>
                    Bussenblick 1<br/>
                    88483 Burgrieden<br/>
                    Germany<br/>
                    <br/>
                    E-Mail: team.shuffle.app@gmail.com
                </p>
            </div>
        </TextContainer>
    );
};
